<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'staffFeesCollection' | translate }}</h1>
      <p class="st-subtitle">{{ 'staffFeesCollection' | translate }}</p>
    </div>

    <div class="sf-year-picker" *ngIf="!fetchingYears && academicInfo.length">
      <button type="button" class="sf-year-btn" (click)="toggleAcademicSelection()">
        <i class="ri-calendar-line"></i>
        {{ selectedYear?.Year }}
        <span class="st-chip st-chip-blue sf-ongoing-badge" *ngIf="isOngoing">{{ 'ongoing' | translate }}</span>
        <i class="ri-arrow-down-s-line"></i>
      </button>
      <div class="sf-year-dropdown" *ngIf="openAcademicSelection">
        <button
          type="button"
          class="sf-year-option"
          *ngFor="let year of academicInfo"
          [class.active]="selectedYear?.pkAcademicId === year.pkAcademicId"
          (click)="changeYear(year)"
        >
          {{ year.Year }}
          <span class="st-chip st-chip-blue" *ngIf="year.pkAcademicId === currentAcademicId">{{ 'ongoing' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Late fees toggle — hidden entirely while loading -->
  <div class="sf-late-fees-row" *ngIf="!fetchingData">
    <span class="sf-late-fees-label">{{ 'lateFees' | translate }}</span>
    <button type="button" class="sf-switch" [class.on]="applyLateFees" (click)="toggleLateFees()">
      <span class="sf-switch-knob"></span>
    </button>
  </div>

  <!-- Trend chart -->
  <div class="st-card sf-chart-card">
    <div class="sf-chart-head">
      <h3 class="st-card-title">{{ 'monthlyCollectionTrend' | translate }}</h3>
      <button type="button" class="sf-graph-toggle" (click)="toggleGraph()">
        <i [ngClass]="openGraph ? 'ri-line-chart-fill' : 'ri-line-chart-line'"></i>
      </button>
    </div>

    <div class="sf-skeleton-chart" *ngIf="fetchingData"></div>

    <ng-container *ngIf="!fetchingData">
      <div class="sf-chart-with-axis" *ngIf="openGraph && feesData.length">
        <div class="sf-y-axis" [style.height.px]="chartHeight">
          <span *ngFor="let label of yAxisLabels">{{ currencySymbol }}{{ label }}</span>
        </div>

        <div class="sf-chart-scroll">
          <div class="sf-chart-svg-wrap" [style.width.px]="chartWidth" [style.height.px]="chartHeight">
            <svg
              class="sf-line-chart"
              [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight"
              [attr.width]="chartWidth"
              [style.height.px]="chartHeight"
              preserveAspectRatio="xMinYMid meet"
            >
              <polyline
                [attr.points]="chartLinePoints"
                fill="none" stroke="url(#sfLineGradient)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <circle
                *ngFor="let p of chartPoints"
                [attr.cx]="p.x" [attr.cy]="p.y" r="4"
                fill="#fff" stroke="var(--brand-primary-color)" stroke-width="2"
                class="sf-chart-dot"
              >
                <title>{{ p.monthYear }}: {{ formatAmount(p.amount) }}</title>
              </circle>
              <defs>
                <linearGradient id="sfLineGradient" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stop-color="var(--brand-primary-color)" />
                  <stop offset="100%" stop-color="var(--accent-purple)" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="sf-line-labels" [style.width.px]="chartWidth">
            <span *ngFor="let p of chartPoints" [style.width.px]="chartWidth / chartPoints.length">{{ p.label }}</span>
          </div>
        </div>
      </div>

      <p class="sf-empty" *ngIf="!feesData.length">{{ 'noDataAvailable' | translate }}</p>
    </ng-container>
  </div>

  <!-- Month tiles -->
  <div class="st-card sf-months-card">
    <h3 class="st-card-title">{{ 'selectAMonth' | translate }}</h3>

    <div class="sf-month-grid" *ngIf="fetchingData">
      <div class="sf-month-tile sf-month-tile-skeleton" *ngFor="let s of skeletonTiles"></div>
    </div>

    <ng-container *ngIf="!fetchingData">
      <div class="sf-month-grid" *ngIf="feesData.length">
        <button
          type="button"
          class="sf-month-tile"
          [class.sf-month-tile-empty]="monthAmount(m) <= 0"
          *ngFor="let m of feesData"
          (click)="openMonth(m)"
        >
          <span class="sf-month-tile-label">{{ m.monthYear }}</span>
          <span class="sf-month-tile-amount">{{ formatAmount(monthAmount(m)) }}</span>
        </button>
      </div>

      <p class="sf-empty" *ngIf="!feesData.length">{{ 'noDataAvailable' | translate }}</p>
    </ng-container>
  </div>
</div>
